// check removeEventQueryParams in src/app/utils/index.ts
export const ExpandedEventInUrl = {
    event: 'e',
    type: 't',
    odd: 'o',
    sbValue: 'sb',
    competitionTab: 'ct',
    marketGroup: 'marketGroup',
    selectedTab: 'mdt',
    /**
     * @deprecated Should no longer be necessary after we roll out link simplification
     */
    tournamentId: 'ti',
    competitionId: 'cpi',
    seasonId: 'si',
} as const;
export type ExpandedEventInUrl = typeof ExpandedEventInUrl[keyof typeof ExpandedEventInUrl];

export const AccordionState = {
    Expanded: 'expanded',
    Collapsed: 'collapsed',
} as const;
export type AccordionState = typeof AccordionState[keyof typeof AccordionState];

export const ArticleEventCardSource = {
    Default: 'Article_Default',
    Segment: 'Article_Segment',
} as const;

export const CompetitionEventCardSource = {
    Default: 'Competition_Default',
} as const;

export const FavouritesEventCardSource = {
    Default: 'Favourites_Default',
} as const;

export const HomeEventCardSource = {
    Default: 'Home_Default',
    InPlay: 'Home_InPlay',
    SuperAdvantage: 'Home_SuperAdvantage',
    SuperExtra: 'Home_SuperExtra',
    SuperLive: 'Home_SuperLive',
    SuperOdds: 'Home_SuperOdds',
    Top10: 'Home_Top10',
} as const;

export const SearchEventCardSource = {
    Default: 'Search_Default',
} as const;

export const SportsEventCardSource = {
    Default: 'Sports_Default',
    PopularEvents: 'Sports_PopularEvents',
} as const;

export const SuperAdvantageSource = {
    Default: 'SuperAdvantage_Default',
} as const;

export type EventCardSource =
    typeof ArticleEventCardSource[keyof typeof ArticleEventCardSource] |
    typeof CompetitionEventCardSource[keyof typeof CompetitionEventCardSource] |
    typeof FavouritesEventCardSource[keyof typeof FavouritesEventCardSource] |
    typeof HomeEventCardSource[keyof typeof HomeEventCardSource] |
    typeof SearchEventCardSource[keyof typeof SearchEventCardSource] |
    typeof SportsEventCardSource[keyof typeof SportsEventCardSource] |
    typeof SuperAdvantageSource[keyof typeof SuperAdvantageSource];
